export const EVT_MESSAGE_FROM_FRIEND = "message-from-friend";
export const EVT_MESSAGE_TO_FRIEND = "message-to-friend";
export const EVT_MESSAGE_READ_BY_FRIEND = "message-read-by-friend";
